module.exports = __webpack_public_path__ + "img/minus.f84e07c7.svg";